'use strict';
journalController.$inject = [
	'$scope',
	'$rootScope',
	'$q',
	'$uibModal',
	'$interval',
	'dialogHelper',
	'dialogSearchHelper',
	'reportHelper',
	'authService',
	'utilsService',
	'transactionhistoryService',
	'unitService',
	'accountStructureService',
	'JOURNAL_TYPES',
	'ACCOUNT_TYPES',
	'USER_CLAIMS',
	'BUSY_MESSAGE',
	'ROLE_CLAIMS',
];
angular.module('schoolLinqApp').controller('journalController', journalController);

function journalController(
	$scope,
	$rootScope,
	$q,
	$uibModal,
	$interval,
	dialogHelper,
	dialogSearchHelper,
	reportHelper,
	authService,
	utilsService,
	transactionhistoryService,
	unitService,
	accountStructureService,
	JOURNAL_TYPES,
	ACCOUNT_TYPES,
	USER_CLAIMS,
	BUSY_MESSAGE,
	ROLE_CLAIMS
) {
	var viewModel = getViewModel($rootScope.mode || 'fund', $rootScope.page || 'JournalEntries');
	$scope.vm = viewModel;

	$scope.loadingPromise = $q
		.all([
			$scope.vm.loadJournalCodes($scope.vm),
			$scope.vm.loadAccountStructures($scope.vm),
			$scope.vm.loadFiscalYears($scope.vm),
			$scope.vm.loadCurrentFY($scope.vm),
			$scope.vm.loadUsesNcNewAcctStructure($scope.vm),
		])
		.then(function () {
			$scope.vm.filter.fiscalYear = $scope.vm.currentFY;
			$scope.vm.getJournalEntries();
		});

	function getViewModel(moduleName, pageName) {
		var fieldClaims = authService.authentication.fieldClaims;
		var docMgmtPermission = null; // authService.hasPageClaim(payableClaims, 'JournalEntriesDocMgmt', USER_CLAIMS.fund, 'accounts');

		var model = {
			module: moduleName,
			page: pageName,
			pageTitle: pageName === 'JournalEntries' ? 'Journal Entries' : pageName,
			journalEntries: [],
			savedJournalEntries: [],
			savedJournalEntriesCount: 0,
			journalCodes: [],
			addModalJournalCodes: [],
			fiscalYears: [],
			selectedFiscalYear: null,
			unifiedAccountMask: null,
			unifiedFundElementIndex: null,
			assetFundElementIndex: 0,
			liabilityFundElementIndex: 0,
			reserveFundElementIndex: 0,
			expenseFundElementIndex: 0,
			revenueFundElementIndex: 0,
			netFundElementIndex: 0,
			usesNcNewAcctStructure: false,
			filter: {
				journalCode: 'AJ',
				fromOpened: false,
				from: new Date(),
				to: new Date(),
				toOpened: false,
				fiscalYear: null,
				thirteenth: false,
				excludeThirteenth: true,
				refNo: '',
				groupByRefNo: true,
				propertyName: 'EffectiveDT',
				reverse: false,
			},
			barLimit: 8,
			startIndex: 0,
			currentFY: null,
			errors: null,
			isReadOnly: authService.isReadOnly(USER_CLAIMS.lsb, pageName, 'accounts'),
			docMgmt: {
				permissionLevel: docMgmtPermission,
				hasConfidentialAccess: !!_.findWhere(fieldClaims, {
					ClaimValue: ROLE_CLAIMS.FundManagementJournalEntriesDocMgmtConfidential,
				}),
				hasDeleteAccess: !!_.findWhere(fieldClaims, {
					ClaimValue: ROLE_CLAIMS.FundManagementJournalEntriesDocMgmtDelete,
				}),
			},
		};

		function loadAccountStructures(model) {
			return accountStructureService.getStructure().then(_.partial(finishLoadingAccountStructures, model));

			function finishLoadingAccountStructures(model, response) {
				model.unifiedAccountMask = response.data.accountStructure.UnifiedAccountMask;
				model.unifiedFundElementIndex = response.data.accountStructure.UnifiedElementFundIndex;
				model.assetFundElementIndex = response.data.accountStructure.AssetElementFundIndex;
				model.expenseFundElementIndex = response.data.accountStructure.ExpenseElementFundIndex;
				model.liabilityFundElementIndex = response.data.accountStructure.LiabilityElementFundIndex;
				model.reserveFundElementIndex = response.data.accountStructure.ReserveElementFundIndex;
				model.revenueFundElementIndex = response.data.accountStructure.RevenueElementFundIndex;
				model.netFundElementIndex = response.data.accountStructure.NetElementFundIndex;
				return angular.noop;
			}
		}

		function loadFiscalYears(model) {
			return transactionhistoryService.getFiscalYears().then(_.partial(finishLoadingFiscalYears, model));

			function finishLoadingFiscalYears(model, response) {
				model.fiscalYears = response.data.years;
				model.selectedFiscalYear = response.data.currentYear;
				model.priorSelectedFiscalYear = model.selectedFiscalYear;
			}
		}

		function loadCurrentFY(model) {
			return unitService.getCurrentFiscalYear().then(_.partial(finishLoadingCurrentFY, model));

			function finishLoadingCurrentFY(model, response) {
				model.currentFY = response.data.currentFiscalYear;
				return angular.noop;
			}
		}

		function loadUsesNcNewAcctStructure(model) {
			return accountStructureService.usesNcNewAcctStructure().then(_.partial(finishLoadingUsesNcNewAcctStructure, model));

			function finishLoadingUsesNcNewAcctStructure(model, response) {
				model.usesNcNewAcctStructure = response.data.usesNcNewAcctStructure;
				return angular.noop;
			}
		}

		function toggleThirteenthOption(model) {
			model.filter.thirteenth = !model.filter.thirteenth;
			if (model.filter.thirteenth === true) {
				model.filter.excludeThirteenth = false;
			}
		}

		function getJournalEntries(model) {
			var filter = _.clone(model.filter);

			if (filter.excludeThirteenth === true) {
				filter.thirteenth = false;
			}
			if (filter.thirteenth === false) {
				filter.fiscalYear = null;
				if (filter.excludeThirteenth === false) {
					filter.thirteenth = null;
				}
			}
			if (model.page === 'JournalEntries') {
				filter.journalTypeId = null;
			} else if (model.page === 'Transfers') {
				filter.journalTypeId = JOURNAL_TYPES.Transfer;
			}

			$scope.loadingPromise = transactionhistoryService.search(filter).then(_.partial(finishLoadingJournalEntries, model));

			function finishLoadingJournalEntries(model, response) {
				model.journalEntries = response.data.history;
				angular.forEach(model.journalEntries, function (entryGroup) {
					entryGroup.limit = 2;
					entryGroup.origLimit = entryGroup.limit;

					// if the user is moving money between a Net account and an Expense account
					// then the Net account will behave as if it was an Expense account also.
					let haveNet = _.some(entryGroup.Transactions, function (xact) {
						return xact.Account.AccountTypeId === ACCOUNT_TYPES.Net;
					});
					let haveExp = _.some(entryGroup.Transactions, function (xact) {
						return xact.Account.AccountTypeId === ACCOUNT_TYPES.Expense;
					});
					let hasNetAndExpense = haveNet && haveExp;
					angular.forEach(entryGroup.Transactions, function (entry) {
						setEntryAmounts(model, entry, hasNetAndExpense);
					});
				});

				return angular.noop;
			}
		}

		function loadJournalCodes(model) {
			return utilsService.getjournalCodes().then(_.partial(finishLoadingJournalCodes, model));

			function finishLoadingJournalCodes(model, response) {
				model.journalCodes = _.filter(response.data.codes, function (code) {
					if (model.module === 'lsb') {
						return code.Code === 'AJ';
					}
					return code.Code === 'AJ' || code.Code === 'BJ' || code.Code === 'CN';
				});

				model.addModalJournalCodes = _.filter(response.data.codes, function (code) {
					if (model.module === 'lsb') {
						return code.Code === 'AJ';
					}
					return code.Code === 'AJ' || code.Code === 'BJ';
				});
			}
		}

		function getSavedJournalEntriesCount(model) {
			$scope.loadingPromise = transactionhistoryService
				.getSavedJournalEntriesCount()
				.then(_.partial(finishLoadingSavedJournalEntriesCount, model));

			function finishLoadingSavedJournalEntriesCount(model, response) {
				model.savedJournalEntriesCount = response.data.savedJournalEntriesCount;
				return angular.noop;
			}
		}

		function getSavedJournalEntries(model) {
			$scope.loadingPromise = transactionhistoryService.getSavedJournalEntries().then(_.partial(finishLoadingSavedJournalEntries, model));

			function finishLoadingSavedJournalEntries(model, response) {
				model.savedJournalEntries = response.data.savedJournalEntries;
				return angular.noop;
			}
		}

		//
		// sets Debit/Credit Amounts or From/To Amounts
		// based on the Amount from the TransactionHistory table
		//
		function setEntryAmounts(model, entry, hasNetAndExpense) {
			if (model.page === 'JournalEntries') {
				if (entry.Amount < 0) {
					entry.DebitAmount = null;
					entry.CreditAmount = entry.Amount * -1;
				} else {
					entry.DebitAmount = entry.Amount;
					entry.CreditAmount = null;
				}
			} else if (model.page === 'Transfers') {
				if (entry.Account.AccountTypeId === ACCOUNT_TYPES.Asset || entry.Account.AccountTypeId === ACCOUNT_TYPES.Expense) {
					if (entry.Amount < 0) {
						entry.FromAmount = entry.Amount * -1;
						entry.ToAmount = null;
					} else {
						entry.FromAmount = null;
						entry.ToAmount = entry.Amount;
					}
				} else if (
					entry.Account.AccountTypeId === ACCOUNT_TYPES.Liability ||
					entry.Account.AccountTypeId === ACCOUNT_TYPES.Reserve ||
					entry.Account.AccountTypeId === ACCOUNT_TYPES.Revenue
				) {
					if (entry.Amount < 0) {
						entry.FromAmount = null;
						entry.ToAmount = entry.Amount * -1;
					} else {
						entry.FromAmount = entry.Amount;
						entry.ToAmount = null;
					}
				} else if (entry.Account.AccountTypeId === ACCOUNT_TYPES.Net) {
					if (hasNetAndExpense) {
						if (entry.Amount < 0) {
							entry.FromAmount = entry.Amount * -1;
							entry.ToAmount = null;
						} else {
							entry.FromAmount = null;
							entry.ToAmount = entry.Amount;
						}
					} else {
						if (entry.Amount < 0) {
							entry.FromAmount = null;
							entry.ToAmount = entry.Amount * -1;
						} else {
							entry.FromAmount = entry.Amount;
							entry.ToAmount = null;
						}
					}
				}
			}
		}

		//
		// sets Debit/Credit Amounts or From/To Amounts for a VOID
		// based on the Amount from the TransactionHistory table
		//
		function setEntryAmountsForVoid(model, entry, hasNetAndExpense) {
			if (model.page === 'JournalEntries') {
				if (entry.Amount < 0) {
					entry.DebitAmount = entry.Amount * -1;
					entry.CreditAmount = null;
				} else {
					entry.DebitAmount = null;
					entry.CreditAmount = entry.Amount;
				}
			} else if (model.page === 'Transfers') {
				if (entry.Account.AccountTypeId === ACCOUNT_TYPES.Asset || entry.Account.AccountTypeId === ACCOUNT_TYPES.Expense) {
					if (entry.Amount < 0) {
						entry.FromAmount = null;
						entry.ToAmount = entry.Amount * -1;
					} else {
						entry.FromAmount = entry.Amount;
						entry.ToAmount = null;
					}
				} else if (
					entry.Account.AccountTypeId === ACCOUNT_TYPES.Liability ||
					entry.Account.AccountTypeId === ACCOUNT_TYPES.Reserve ||
					entry.Account.AccountTypeId === ACCOUNT_TYPES.Revenue
				) {
					if (entry.Amount < 0) {
						entry.FromAmount = entry.Amount * -1;
						entry.ToAmount = null;
					} else {
						entry.FromAmount = null;
						entry.ToAmount = entry.Amount;
					}
				} else if (entry.Account.AccountTypeId === ACCOUNT_TYPES.Net) {
					if (hasNetAndExpense) {
						if (entry.Amount < 0) {
							entry.FromAmount = null;
							entry.ToAmount = entry.Amount * -1;
						} else {
							entry.FromAmount = entry.Amount;
							entry.ToAmount = null;
						}
					} else {
						if (entry.Amount < 0) {
							entry.FromAmount = entry.Amount * -1;
							entry.ToAmount = null;
						} else {
							entry.FromAmount = null;
							entry.ToAmount = entry.Amount;
						}
					}
				}
			}
		}

		//
		// gets Amount for the TransactionHistory table
		// based on the Debit/Credit Amounts or From/To Amounts
		//
		function getAmountForTransactionHistoryTable(model, entry, hasNetAndExpense) {
			if (model.page === 'JournalEntries') {
				return parseFloat(entry.CreditAmount) ? parseFloat(entry.CreditAmount * -1) : parseFloat(entry.DebitAmount);
			} else if (model.page === 'Transfers') {
				if (entry.Account.AccountTypeId === ACCOUNT_TYPES.Asset || entry.Account.AccountTypeId === ACCOUNT_TYPES.Expense) {
					return parseFloat(entry.FromAmount) ? parseFloat(entry.FromAmount * -1) : parseFloat(entry.ToAmount);
				} else if (
					entry.Account.AccountTypeId === ACCOUNT_TYPES.Liability ||
					entry.Account.AccountTypeId === ACCOUNT_TYPES.Reserve ||
					entry.Account.AccountTypeId === ACCOUNT_TYPES.Revenue
				) {
					return parseFloat(entry.FromAmount) ? parseFloat(entry.FromAmount) : parseFloat(entry.ToAmount * -1);
				} else if (entry.Account.AccountTypeId === ACCOUNT_TYPES.Net) {
					if (hasNetAndExpense) {
						return parseFloat(entry.FromAmount) ? parseFloat(entry.FromAmount * -1) : parseFloat(entry.ToAmount);
					} else {
						return parseFloat(entry.FromAmount) ? parseFloat(entry.FromAmount) : parseFloat(entry.ToAmount * -1);
					}
				}
			}
		}

		function voidJournalEntry(model, journalEntry) {
			$scope.selectedJournalEntry = angular.copy(journalEntry);
			$uibModal
				.open({
					template: require('@ajs/templates/fund/account/journalEntry-void-modal.html'),
					backdrop: 'static',
					keyboard: false,
					scope: $scope,
					size: 'topMoveUp',
					controller: [
						'$scope',
						'$uibModalInstance',
						function ($scope, modalInstance) {
							$scope.selectedJournalEntry.EffectiveDT = moment($scope.selectedJournalEntry.EffectiveDT).toDate();
							$scope.selectedJournalEntry.VoidDT = $scope.selectedJournalEntry.EffectiveDT;
							let haveNet = _.some($scope.selectedJournalEntry.Transactions, function (xact) {
								return xact.Account.AccountTypeId === ACCOUNT_TYPES.Net;
							});
							let haveExp = _.some($scope.selectedJournalEntry.Transactions, function (xact) {
								return xact.Account.AccountTypeId === ACCOUNT_TYPES.Expense;
							});
							let hasNetAndExpense = haveNet && haveExp;
							$scope.selectedJournalEntry.Transactions = _.map($scope.selectedJournalEntry.Transactions, function (entry) {
								let voidText = 'V - ';
								if (!entry.Description) {
									entry.Description = voidText;
								} else {
									if (entry.Description.length > 100 - voidText.length) {
										entry.Description = entry.Description.substring(0, 100 - voidText.length);
									}
									entry.Description = voidText + entry.Description;
								}
								setEntryAmountsForVoid(model, entry, hasNetAndExpense);
								return entry;
							});
							$scope.barLimit = 4;
							$scope.startIndex = 0;

							angular.extend($scope, {
								cancel: function () {
									modalInstance.close();
								},
								voidEntry: function () {
									$scope.journalEntryForm.$setSubmitted();
									if ($scope.journalEntryForm.$invalid) return;
									// ensure void date is not prior to original effective date
									if ($scope.selectedJournalEntry.VoidDT < $scope.selectedJournalEntry.EffectiveDT) {
										$scope.voidErrors = [];
										$scope.voidErrors.push('Void date cannot be earlier than the original effective date.');
										return;
									}
									// confirm if void outside of current FY or void not in same FY as original entries
									$scope.loadingPromise = $q
										.all([
											unitService.getFiscalYearFromDate($scope.selectedJournalEntry.EffectiveDT),
											unitService.getFiscalYearFromDate($scope.selectedJournalEntry.VoidDT),
										])
										.then(function (responses) {
											if (responses[0].data.isValid && responses[1].data.isValid) {
												var origFY = responses[0].data.fiscalYear;
												var voidFY = responses[1].data.fiscalYear;
												if (origFY !== voidFY || voidFY !== model.currentFY) {
													let messages = [];
													if (origFY !== voidFY) {
														messages.push(
															'The original fiscal year (' +
																origFY +
																') is different than the void fiscal year (' +
																voidFY +
																').'
														);
													}
													if (voidFY !== model.currentFY) {
														messages.push('The date of the voiding entries is not in the current fiscal year.');
													}
													messages.push('Do you want to save anyway?');

													let title = 'Confirm Variation in Current Fiscal Year';
													let msgDetail = 'Please confirm the following:';
													dialogHelper.yesnoMessageBox(title, msgDetail, messages, 'Question', yesFunction, noFunction);
												} else {
													return $scope.voidEntryForReal();
												}
											} else {
												return $scope.voidEntryForReal();
											}
										});

									function yesFunction() {
										$scope.voidEntryForReal();
									}

									function noFunction() {
										return;
									}
								},
								voidEntryForReal: function () {
									var journalEntries = [];

									let journalTypeId = $scope.vm.page === 'Transfers' ? JOURNAL_TYPES.Transfer : null;
									let haveNet = _.some($scope.selectedJournalEntry.Transactions, function (xact) {
										return xact.Account.AccountTypeId === ACCOUNT_TYPES.Net;
									});
									let haveExp = _.some($scope.selectedJournalEntry.Transactions, function (xact) {
										return xact.Account.AccountTypeId === ACCOUNT_TYPES.Expense;
									});
									let hasNetAndExpense = haveNet && haveExp;
									angular.forEach($scope.selectedJournalEntry.Transactions, function (entry) {
										if (entry.Account) {
											journalEntries.push({
												EffectiveDT: $scope.selectedJournalEntry.VoidDT,
												JournalCode: $scope.selectedJournalEntry.JournalCode,
												ReferenceNo: $scope.selectedJournalEntry.ReferenceNo,
												TransactionGUID: $scope.selectedJournalEntry.TransactionGUID,
												Description: entry.Description,
												AccountId: entry.Account.Id,
												Amount: $scope.vm.getAmountForTransactionHistoryTable(entry, hasNetAndExpense),
												ThirteenthMonth: $scope.selectedJournalEntry.Thirteenth,
												JournalTypeId: journalTypeId,
												IsVoid: true,
											});
										}
									});

									$scope.voidingEntriesPromise = transactionhistoryService
										.addJournalEntries(journalEntries)
										.then(_.partial(finishLoadingJournalEntries, model));

									function finishLoadingJournalEntries(model, response) {
										if (response.data.isValid) {
											modalInstance.close(true);
										} else {
											$scope.voidErrors = response.data.errors;
										}
									}
								},
							});
						},
					],
				})
				.result.then(function (hasbeenVoided) {
					if (hasbeenVoided) {
						model.getJournalEntries();
					}
					$scope.selectedJournalEntry = null;
				});
		}

		function addJournalEntries(model, journalEntry) {
			$scope.selectedJournalEntry = journalEntry;
			$uibModal
				.open({
					template: require('@ajs/templates/fund/account/journalEntry-add-modal.html'),
					backdrop: 'static',
					keyboard: false,
					scope: $scope,
					windowClass: 'mediumModal',
					controller: [
						'$scope',
						'$filter',
						'$uibModalInstance',
						'accountService',
						'unitService',
						'transactionhistoryService',
						'dialogHelper',
						function ($scope, $filter, modalInstance, accountService, unitService, transactionhistoryService, dialogHelper) {
							$scope.barLimit = 8;
							$scope.startIndex = 0;
							$scope.pageControl = {};

							$scope.newJournalEntryDateOpened = false;
							$scope.isRetrieved = false;

							$scope.loadingEntries = transactionhistoryService
								.getSavedJournalEntriesCount()
								.then(_.partial(finishLoadingCount, model));

							function finishLoadingCount(model, response) {
								model.savedJournalEntriesCount = response.data.savedJournalEntriesCount;
								return angular.noop;
							}

							if ($scope.selectedJournalEntry) {
								$scope.newJournalEntry = {
									date: new Date(new Date().setHours(0, 0, 0)),
									generateReport: model.page === 'JournalEntries' ? true : false,
									thirteenth: $scope.selectedJournalEntry.Thirteenth,
									referenceNo: $scope.selectedJournalEntry.ReferenceNo,
									journalCode: $scope.selectedJournalEntry.JournalCode,
								};
								let haveNet = _.some($scope.selectedJournalEntry.Transactions, function (xact) {
									return xact.Account.AccountTypeId === ACCOUNT_TYPES.Net;
								});
								let haveExp = _.some($scope.selectedJournalEntry.Transactions, function (xact) {
									return xact.Account.AccountTypeId === ACCOUNT_TYPES.Expense;
								});
								let hasNetAndExpense = haveNet && haveExp;
								$scope.newJournalEntries = _.map(angular.copy($scope.selectedJournalEntry.Transactions), function (entry) {
									setEntryAmounts(model, entry, hasNetAndExpense);
									return entry;
								});
							} else {
								transactionhistoryService.getNextReferenceNo().then(function (response) {
									var nextRefNo = '';
									if (response.data.isValid) nextRefNo = response.data.nextRefNo;
									$scope.newJournalEntry = {
										date: new Date(new Date().setHours(0, 0, 0)),
										generateReport: model.page === 'JournalEntries' ? true : false,
										thirteenth: false,
										referenceNo: nextRefNo,
									};
									if ($scope.vm.journalCodes.length === 1) {
										$scope.newJournalEntry.journalCode = $scope.vm.journalCodes[0].Code;
									}
									$scope.newJournalEntries = Array(2);
									$scope.newJournalEntries = _.map($scope.newJournalEntries, function (key) {
										return {};
									});
									return angular.noop;
								});
							}

							angular.extend($scope, {
								cancel: function () {
									modalInstance.close();
								},
								getAccountTypesForLookup: function () {
									let accountTypeIds = [];

									if (model.page === 'JournalEntries') {
										if ($scope.newJournalEntry && $scope.newJournalEntry.journalCode === 'BJ') {
											// no Asset or Liability accounts for BJ entries
											accountTypeIds.push(ACCOUNT_TYPES.Reserve);
											accountTypeIds.push(ACCOUNT_TYPES.Revenue);
											accountTypeIds.push(ACCOUNT_TYPES.Expense);
										} else {
											accountTypeIds.push(USER_CLAIMS.allAccess);
										}
									} else if (model.page === 'Transfers') {
										// if no account has been selected then make all Account Types available
										// if an account has been selected then only allow that Account Type
										// ... unless its one of the allowable combinations
										let typeId = USER_CLAIMS.allAccess;
										let entry = _.find($scope.newJournalEntries, function (entry) {
											return !_.isUndefined(entry.Account);
										});

										if (!_.isUndefined(entry)) {
											//
											// Allow for certain combinations
											//
											let haveExp = _.some($scope.newJournalEntries, function (xact) {
												return !_.isUndefined(xact.Account) ? xact.Account.AccountTypeId === ACCOUNT_TYPES.Expense : false;
											});
											let haveRev = _.some($scope.newJournalEntries, function (xact) {
												return !_.isUndefined(xact.Account) ? xact.Account.AccountTypeId === ACCOUNT_TYPES.Revenue : false;
											});
											let haveNet = _.some($scope.newJournalEntries, function (xact) {
												return !_.isUndefined(xact.Account) ? xact.Account.AccountTypeId === ACCOUNT_TYPES.Net : false;
											});

											if (haveExp) {
												accountTypeIds.push(ACCOUNT_TYPES.Expense);
												typeId = ACCOUNT_TYPES.Net;
											} else if (haveRev) {
												accountTypeIds.push(ACCOUNT_TYPES.Revenue);
												typeId = ACCOUNT_TYPES.Net;
											} else if (haveNet) {
												accountTypeIds.push(ACCOUNT_TYPES.Expense);
												accountTypeIds.push(ACCOUNT_TYPES.Revenue);
												typeId = ACCOUNT_TYPES.Net;
											} else {
												typeId = entry.Account.AccountTypeId;
											}
										}
										accountTypeIds.push(typeId);
									}

									return accountTypeIds;
								},
								selectAccountFromList: function (item) {
									const modalConfig = {
										accountTypeIds: $scope.getAccountTypesForLookup(),
										allowAddNew: false,
										moduleName: $scope.vm.module,
									};

									const selectFunction = function (account) {
										item.Account = account;

										$scope.journalEntryForm.$dirty = true;
									};

									dialogSearchHelper.searchAccounts(modalConfig, selectFunction);
								},
								searchAccountsbyAccountNumber: function (value, limit) {
									let typeaheadLimit = limit != null ? limit : 12;
									const accountTypeIds = $scope.getAccountTypesForLookup();

									return accountService.searchAccount(accountTypeIds, '', value, typeaheadLimit, true).then(finishSearchAccounts);

									function finishSearchAccounts(response) {
										return response.data.accounts;
									}
								},
								importEntries: function () {
									$scope.journalImport = [];
									$uibModal
										.open({
											template: require('@ajs/templates/fund/account/journalEntry-import-modal.html'),
											backdrop: 'static',
											keyboard: false,
											scope: $scope,
											size: 'topMoveUp',
											controller: [
												'$scope',
												'$uibModalInstance',
												'$filter',
												function ($scope, modalInstance, $filter) {
													angular.extend($scope, {
														cancel: function () {
															modalInstance.close();
														},
														open: function () {
															document.getElementById('journalImport').click();
														},
														importDoc: function () {
															if ($scope.fileName) {
																modalInstance.close($scope.journalDocImport);
															}
														},
													});
												},
											],
										})
										.result.then(function (journalImports) {
											if (journalImports) {
												var promises = [];
												var entryNumber = 0; // entry #1 will be the first entry to import
												angular.forEach(journalImports, function (entry) {
													entryNumber++;
													entry.entryNumber = entryNumber;
													if (entry.DebitAmount) entry.DebitAmount = emsRound(entry.DebitAmount);
													if (entry.CreditAmount) entry.CreditAmount = emsRound(entry.CreditAmount);
													promises.push(
														$scope.searchAccountsbyAccountNumber(entry.AccountNumber).then(function (account) {
															return $scope.journalImport.push(
																_.extend(entry, {
																	Account: account && account.length > 0 ? account[0] : null,
																	found: account && account.length > 0 ? true : false,
																})
															);
														})
													);
												});
												$scope.savingNewEntriesPromise = $q.all(promises).then(function () {
													return $uibModal
														.open({
															template: require('@ajs/templates/fund/account/journalEntry-confirm-import-modal.html'),
															backdrop: 'static',
															keyboard: false,
															scope: $scope,
															size: 'topMoveUp',
															controller: [
																'$scope',
																'$uibModalInstance',
																'$filter',
																function ($scope, modalInstance, $filter) {
																	$scope.validImportCount = $filter('filter')($scope.journalImport, {
																		found: true,
																	}).length;
																	$scope.errorItems = $filter('filter')($scope.journalImport, { found: false });
																	$scope.errorImportCount = $scope.errorItems.length;

																	angular.extend($scope, {
																		cancel: function () {
																			modalInstance.close();
																		},
																		confirm: function () {
																			modalInstance.close('updateView');
																		},
																		print: function () {
																			var report = {
																				ErrorItems: $scope.errorItems,
																			};
																			reportHelper.postReport(
																				$scope,
																				'/api/fundreports/journalentryimporterrors',
																				report,
																				'JournalEntryImportErrors.pdf'
																			);
																		},
																	});
																},
															],
														})
														.result.then(function (updateView) {
															if (updateView) {
																$scope.newJournalEntries = _.filter($scope.newJournalEntries, function (entry) {
																	return entry.Account;
																});
																$scope.newJournalEntries = $scope.newJournalEntries.concat(
																	$filter('filter')($scope.journalImport, {
																		found: true,
																	})
																);
																$scope.newJournalEntries = _.sortBy($scope.newJournalEntries, function (entry) {
																	return entry.entryNumber;
																});
															}
															return angular.noop;
														});
												});
											}
										});
								},
								retrieveEntries: function () {
									$scope.isRetrieved = true;

									if (model.savedJournalEntriesCount === 1) {
										$scope.loadingEntries = transactionhistoryService.getSavedJournalEntries().then(function (response) {
											if (response.data.isValid) {
												$scope.selectedJournalEntry = response.data.savedJournalEntries[0];
												$scope.newJournalEntry = {
													date: moment($scope.selectedJournalEntry.EffectiveDT).toDate(),
													generateReport: model.page === 'JournalEntries' ? true : false,
													thirteenth: $scope.selectedJournalEntry.Thirteenth,
													referenceNo: $scope.selectedJournalEntry.ReferenceNo,
													transactionGUID: $scope.selectedJournalEntry.TransactionGUID,
													journalCode: $scope.selectedJournalEntry.JournalCode,
												};
												let haveNet = _.some($scope.selectedJournalEntry.Transactions, function (xact) {
													return xact.Account.AccountTypeId === ACCOUNT_TYPES.Net;
												});
												let haveExp = _.some($scope.selectedJournalEntry.Transactions, function (xact) {
													return xact.Account.AccountTypeId === ACCOUNT_TYPES.Expense;
												});
												let hasNetAndExpense = haveNet && haveExp;
												$scope.newJournalEntries = _.map($scope.selectedJournalEntry.Transactions, function (entry) {
													setEntryAmounts(model, entry, hasNetAndExpense);
													return entry;
												});
												// set the form to dirty so the Retrieve button goes away.
												$scope.journalEntryForm.$setDirty();
											}
											return angular.noop;
										});
									} else {
										// open the Retrieve Saved Entries modal
										$uibModal
											.open({
												template: require('@ajs/templates/fund/account/journalEntry-saved-modal.html'),
												backdrop: 'static',
												keyboard: false,
												scope: $scope,
												size: 'topMoveUp',
												controller: [
													'$scope',
													'$filter',
													'$uibModalInstance',
													'transactionhistoryService',
													function ($scope, $filter, modalInstance, transactionhistoryService) {
														model.savedJournalEntryStartIndex = 0;
														model.savedJournalEntryBarLimit = 10;

														$scope.filteredList = [];

														$scope.loadingEntries = transactionhistoryService
															.getSavedJournalEntries()
															.then(function (response) {
																if (response.data.isValid) {
																	$scope.savedEntries = response.data.savedJournalEntries;
																}
																return angular.noop;
															});

														angular.extend($scope, {
															cancel: function () {
																modalInstance.close();
															},
															removeEntry: function (journalEntry) {
																const fnYesDelete = function () {
																	let index = _.findIndex($scope.savedEntries, {
																		$$hashKey: journalEntry.$$hashKey,
																	});
																	$scope.savedEntries.splice(index, 1);
																	model.savedJournalEntriesCount -= 1;

																	transactionhistoryService
																		.deleteSavedJournalEntries(journalEntry.TransactionGUID)
																		.then(function (response) {
																			if (!response.data.isValid) {
																				$scope.errors = response.data.errors;
																				dialogHelper.openMessageBox('Error', $scope.errors, null, 'Warning');
																			} else {
																				if (model.savedJournalEntriesCount <= 0) {
																					$scope.cancel();
																				}
																			}
																		});
																};

																let title =
																	'Delete retrieved entries for Reference # ' +
																	journalEntry.ReferenceNo +
																	'.\xa0\xa0\xa0 Are you sure?';
																dialogHelper.yesnoMessageBox(title, null, null, 'Question', fnYesDelete, null);
															},
															selectEntry: function (journalEntry) {
																if (!_.isUndefined(journalEntry.isDelete) && journalEntry.isDelete === true) {
																	journalEntry.isDelete = undefined;
																	return angular.noop;
																}

																$scope.$parent.selectedJournalEntry = journalEntry;
																$scope.$parent.newJournalEntry = {
																	date: moment($scope.selectedJournalEntry.EffectiveDT).toDate(),
																	generateReport: model.page === 'JournalEntries' ? true : false,
																	thirteenth: $scope.selectedJournalEntry.Thirteenth,
																	referenceNo: $scope.selectedJournalEntry.ReferenceNo,
																	transactionGUID: $scope.selectedJournalEntry.TransactionGUID,
																	journalCode: $scope.selectedJournalEntry.JournalCode,
																};
																let haveNet = _.some($scope.selectedJournalEntry.Transactions, function (xact) {
																	return xact.Account.AccountTypeId === ACCOUNT_TYPES.Net;
																});
																let haveExp = _.some($scope.selectedJournalEntry.Transactions, function (xact) {
																	return xact.Account.AccountTypeId === ACCOUNT_TYPES.Expense;
																});
																let hasNetAndExpense = haveNet && haveExp;
																$scope.$parent.newJournalEntries = _.map(
																	$scope.selectedJournalEntry.Transactions,
																	function (entry) {
																		setEntryAmounts(model, entry, hasNetAndExpense);
																		return entry;
																	}
																);
																// set the form to dirty so the Retrieve button goes away.
																$scope.journalEntryForm.$setDirty();
																modalInstance.close();
															},
														});
													},
												],
											})
											.result.then(function (reload) {});
									}
								},
								addRow: function () {
									$scope.newJournalEntries.push({});
									let len = $scope.newJournalEntries.length;
									let maxPgIdx = parseInt(len / $scope.barLimit);
									if (maxPgIdx > $scope.pageControl.currentPageIndex && len % $scope.barLimit !== 0)
										$scope.pageControl.setPageIndex(maxPgIdx);
								},
								removeRow: function (entry) {
									let index = _.findIndex($scope.newJournalEntries, {
										$$hashKey: entry.$$hashKey,
									});
									$scope.newJournalEntries.splice(index, 1);
								},
								creditTotal: function () {
									return _.reduce(
										$scope.newJournalEntries,
										function (total, entry) {
											var value = entry && entry.CreditAmount ? parseFloat(entry.CreditAmount) : 0;
											return total + value;
										},
										0
									);
								},
								debitTotal: function () {
									return _.reduce(
										$scope.newJournalEntries,
										function (total, entry) {
											var value = entry && entry.DebitAmount ? parseFloat(entry.DebitAmount) : 0;
											return total + value;
										},
										0
									);
								},
								fromTotal: function () {
									return _.reduce(
										$scope.newJournalEntries,
										function (total, entry) {
											var value = entry && entry.FromAmount ? parseFloat(entry.FromAmount) : 0;
											return total + value;
										},
										0
									);
								},
								toTotal: function () {
									return _.reduce(
										$scope.newJournalEntries,
										function (total, entry) {
											var value = entry && entry.ToAmount ? parseFloat(entry.ToAmount) : 0;
											return total + value;
										},
										0
									);
								},
								isEffectiveDateWithinCurrentMonth: function () {
									if ($scope.newJournalEntry.thirteenth === true) {
										return true;
									}
									let effectiveMonth = moment($scope.newJournalEntry.date).month();
									let currentMonth = moment().month();
									if (effectiveMonth === currentMonth) return true;
									else return false;
								},
								validateForm: function (postEntries) {
									var hasError = false;
									$scope.error = false;
									$scope.balanceErrors = '';
									$scope.journalEntryForm.$setSubmitted();
									if ($scope.journalEntryForm.$error.required && $scope.journalEntryForm.$error.required.length > 0) {
										hasError = true;
									}

									// make sure every entry has an Account specified
									let entriesWithNoAccount = _.filter($scope.newJournalEntries, function (entry) {
										if (entry.Account === undefined) return true;
									});
									if (entriesWithNoAccount.length !== 0) {
										hasError = true;
										$scope.error = true;
										$scope.balanceErrors += 'All lines must have an account specified.';
										return !hasError;
									}

									var left = model.page === 'JournalEntries' ? $scope.debitTotal() : $scope.fromTotal();
									var right = model.page === 'JournalEntries' ? $scope.creditTotal() : $scope.toTotal();
									var diff = left - right;
									diff = Number(diff.toFixed(2));
									if (diff !== 0 && postEntries) {
										$scope.error = true;
										hasError = true;
									}

									let haveNet = _.some($scope.newJournalEntries, function (xact) {
										return xact.Account.AccountTypeId === ACCOUNT_TYPES.Net;
									});
									let haveExp = _.some($scope.newJournalEntries, function (xact) {
										return xact.Account.AccountTypeId === ACCOUNT_TYPES.Expense;
									});
									let hasNetAndExpense = haveNet && haveExp;

									let accountsByFund = [];
									let newEntry = false;
									let journalEntry;
									for (let i = $scope.newJournalEntries.length - 1; i >= 0; i--) {
										if ($scope.newJournalEntries[i].Account) {
											newEntry = true;
											journalEntry = $scope.newJournalEntries[i];
										}

										let leftAmount =
											model.page === 'JournalEntries'
												? parseFloat($scope.newJournalEntries[i].DebitAmount)
												: parseFloat($scope.newJournalEntries[i].FromAmount);
										let rightAmount =
											model.page === 'JournalEntries'
												? parseFloat($scope.newJournalEntries[i].CreditAmount)
												: parseFloat($scope.newJournalEntries[i].ToAmount);
										if ($scope.newJournalEntries[i].Account && !leftAmount && !rightAmount) {
											$scope.newJournalEntries[i].error = true;
											hasError = true;
										} else {
											$scope.newJournalEntries[i].error = false;
										}

										if (newEntry && !$scope.newJournalEntries[i].error) {
											// figure out what the fund is
											let fundVal = 0;
											// 1st figure out what the FundElementIndex is
											let fundIdx = 0;
											if (model.unifiedFundElementIndex !== null) {
												fundIdx = model.unifiedFundElementIndex;
											} else {
												if (journalEntry.Account.AccountTypeId === ACCOUNT_TYPES.Asset) fundIdx = model.assetFundElementIndex;
												else if (journalEntry.Account.AccountTypeId === ACCOUNT_TYPES.Liability)
													fundIdx = model.liabilityFundElementIndex;
												else if (journalEntry.Account.AccountTypeId === ACCOUNT_TYPES.Reserve)
													fundIdx = model.reserveFundElementIndex;
												else if (journalEntry.Account.AccountTypeId === ACCOUNT_TYPES.Revenue)
													fundIdx = model.revenueFundElementIndex;
												else if (journalEntry.Account.AccountTypeId === ACCOUNT_TYPES.Expense)
													fundIdx = model.expenseFundElementIndex;
												else if (journalEntry.Account.AccountTypeId === ACCOUNT_TYPES.Net)
													fundIdx = model.netFundElementIndex;
											}
											let accountNumElements = journalEntry.Account.AccountNumber.split('.');
											if (model.usesNcNewAcctStructure) {
												fundVal = accountNumElements[fundIdx].substring(0, 1);
											} else {
												fundVal = accountNumElements[fundIdx];
											}

											let fund = _.find(accountsByFund, function (abf) {
												return abf.Fund === fundVal;
											});
											let amount = $scope.vm.getAmountForTransactionHistoryTable(journalEntry, hasNetAndExpense);
											// if we already have an entry for this Fund then add or subtract from its total
											// else create an entry for this Fund
											if (fund) {
												fund.Total += amount;
											} else {
												accountsByFund.push({
													Fund: fundVal,
													Total: amount,
												});
											}
										}
									}

									// The total for each Fund should equal zero
									if (accountsByFund.length > 0) {
										for (let i = accountsByFund.length - 1; i >= 0; i--) {
											// take care of floating point issues
											var total = accountsByFund[i].Total;
											total = Number(total.toFixed(2));

											if (total !== 0 && postEntries) {
												hasError = true;
												let leftAndRight = model.page === 'JournalEntries' ? 'Debits & Credits' : 'From & To';
												$scope.balanceErrors += leftAndRight + ' for Fund ' + accountsByFund[i].Fund + ' - DO NOT BALANCE ';
											}
										}
									}

									if (!newEntry) {
										hasError = true;
										$scope.error = true;
										$scope.balanceErrors += 'There are no Entries with an Account Number ';
									}

									if ($scope.newJournalEntry.journalCode === 'BJ') {
										// do not allow asset or liability accounts with BJ entries
										var invalidAccounts = _.filter($scope.newJournalEntries, function (entry) {
											if (entry.Account === undefined) return false;
											else
												return (
													entry.Account.AccountTypeId === ACCOUNT_TYPES.Asset ||
													entry.Account.AccountTypeId === ACCOUNT_TYPES.Liability
												);
										});
										if (invalidAccounts.length !== 0) {
											hasError = true;
											$scope.error = true;
											$scope.balanceErrors += 'BJ Entries cannot be made on Asset or Liability accounts ';
										}
									}

									return !hasError;
								},
								save: function (postEntries) {
									if ($scope.validateForm(postEntries)) {
										if (!$scope.isEffectiveDateWithinCurrentMonth()) {
											let title = 'Journal Entry Confirmation';
											let msgDetail = 'Effective Date entered is not within the current month. Do you wish to continue?';
											dialogHelper.yesnoMessageBox(title, msgDetail, null, 'Question', yesFunction, noFunction);
										} else {
											$scope.saveForReal(postEntries);
										}
									}

									function yesFunction() {
										$scope.saveForReal(postEntries);
									}

									function noFunction() {
										return;
									}
								},
								saveForReal: function (postEntries) {
									var journalEntries = [];

									// Check to see if any of the entries occur during a closed month (moment months are zero-indexed)
									var mo,
										yr = null;
									if ($scope.newJournalEntry.thirteenth === true) {
										mo = 6;
										yr = model.selectedFiscalYear;
									} else {
										mo = moment($scope.newJournalEntry.date).month() + 1;
										yr = moment($scope.newJournalEntry.date).year();
									}

									model.closedMonth = {
										ActualMonthNumber: mo,
										ActualYear: yr,
										ThirteenthMonth: $scope.newJournalEntry.thirteenth === true,
									};

									var closedMonthsJson = JSON.stringify(model.closedMonth);

									$scope.savingNewEntriesPromise = unitService
										.checkIfMonthsAreClosed(closedMonthsJson)
										.then(_.partial(finishedCheckingClosedMonths, model));

									function finishedCheckingClosedMonths(model, response) {
										if (!response.data.isClosed) {
											if ($scope.newJournalEntry.thirteenth === true) {
												$scope.newJournalEntry.date = moment().set({
													year: model.selectedFiscalYear,
													month: 5,
													date: 30,
												}); // month 5 = June (0-based)
											}
											let journalTypeId = $scope.vm.page === 'Transfers' ? JOURNAL_TYPES.Transfer : null;
											let haveNet = _.some($scope.newJournalEntries, function (xact) {
												return xact.Account.AccountTypeId === ACCOUNT_TYPES.Net;
											});
											let haveExp = _.some($scope.newJournalEntries, function (xact) {
												return xact.Account.AccountTypeId === ACCOUNT_TYPES.Expense;
											});
											let hasNetAndExpense = haveNet && haveExp;
											angular.forEach($scope.newJournalEntries, function (entry) {
												if (entry.Account) {
													journalEntries.push({
														EffectiveDT: $scope.newJournalEntry.date,
														JournalCode: $scope.newJournalEntry.journalCode,
														ReferenceNo: $scope.newJournalEntry.referenceNo,
														TransactionGUID: $scope.newJournalEntry.transactionGUID,
														Description: entry.Description,
														AccountId: entry.Account.Id,
														Amount: $scope.vm.getAmountForTransactionHistoryTable(entry, hasNetAndExpense),
														ThirteenthMonth: $scope.newJournalEntry.thirteenth,
														JournalTypeId: journalTypeId,
													});
												}
											});

											if (postEntries)
												$scope.savingNewEntriesPromise = transactionhistoryService
													.addJournalEntries(journalEntries)
													.then(_.partial(finishLoadingJournalEntries, model));
											else
												$scope.savingNewEntriesPromise = transactionhistoryService
													.addSavedJournalEntries(journalEntries)
													.then(_.partial(finishLoadingJournalEntries, model));
										} else {
											if (model.closedMonth.ThirteenthMonth === true) {
												$scope.closedMonthError =
													'Cannot add entries because the 13th month has been closed or is not yet open.';
											} else {
												var monthYear = model.closedMonth.ActualMonthNumber + '/' + model.closedMonth.ActualYear;
												$scope.closedMonthError =
													'Cannot add entries because month ' + monthYear + ' has been closed or is not yet open.';
											}
										}
									}

									function finishLoadingJournalEntries(model, response) {
										if (response.data.isValid) {
											if ($scope.newJournalEntry.generateReport && postEntries) {
												var reportParams = {
													TransactionGUID: response.data.transactionGuid,
													TransactionGUID: response.data.data.Entity,
													EffectiveDate: $scope.newJournalEntry.date,
													JournalCode: $scope.newJournalEntry.journalCode,
													ReferenceNo: $scope.newJournalEntry.referenceNo,
													ThirteenthMonth: $scope.newJournalEntry.thirteenth,
												};
												openReport(model, reportParams);
											}
											if (response.data.messages.length > 0) {
												dialogHelper.openMessageBox(
													'Successfully created journal entries',
													null,
													response.data.messages,
													'Info'
												);
											}
											modalInstance.close('reLoad');
										} else {
											$scope.addError = response.data.errors;
										}
									}
								},
								deleteRetrievedEntries: function () {
									const fnYesDelete = function () {
										transactionhistoryService
											.deleteSavedJournalEntries($scope.newJournalEntry.transactionGUID)
											.then(function (response) {
												if (!response.data.isValid) {
													$scope.errors = response.data.errors;
													dialogHelper.openMessageBox('Error', $scope.errors, null, 'Warning');
												} else {
													$scope.cancel();
												}
											});
									};

									let title =
										'Delete retrieved entries for Reference # ' +
										$scope.newJournalEntry.referenceNo +
										'.\xa0\xa0\xa0 Are you sure?';
									dialogHelper.yesnoMessageBox(title, null, null, 'Question', fnYesDelete, null);
									return;
								},
							});
						},
					],
				})
				.result.then(function (reLoad) {
					if (reLoad) {
						model.getJournalEntries();
					}
				});
		}

		function openListReport(model) {
			model.message = BUSY_MESSAGE.GeneratingReport;

			var report = {
				FromDT: model.filter.from,
				ToDT: model.filter.to,
				ThirteenthMonth: model.filter.thirteenth,
				ExcludeThirteenth: model.filter.excludeThirteenth,
				FiscalYear: model.filter.fiscalYear,
				JournalCode: model.filter.journalCode,
				VoidsOnly: false,
				ElementRangeModelCol: [],
				PayGroupId: 0,
				PayGroupSort: false,
				RefNo: model.filter.refNo,
				ExcludeNullTransactionGUIDs: true,
			};

			function loadReportAsync() {
				let deferred = $q.defer();
				reportHelper.getReport($scope, '/api/fundreports/journalentrylistreport', report, 'JournalEntryListReport.pdf', function () {
					deferred.resolve();
				});
				return deferred.promise;
			}

			$scope.loadingPromise = loadReportAsync();
		}

		function exportJournalEntries(model) {
			var entries = [];
			if (model.page === 'JournalEntries') {
				entries.push('Date,Code,Ref#,Account#,Description,Debit,Credit');
			} else if (model.page === 'Transfers') {
				entries.push('Date,Code,Ref#,Account#,Description,From,To');
			}
			angular.forEach(model.journalEntries, function (entryGroup) {
				angular.forEach(entryGroup.Transactions, function (entry) {
					let leftAmt = model.page === 'JournalEntries' ? entry.DebitAmount : entry.FromAmount;
					let rightAmt = model.page === 'JournalEntries' ? entry.CreditAmount : entry.ToAmount;
					let itemArray = [];
					itemArray.push(moment(entryGroup.EffectiveDT).format('MM/DD/YYYY'));
					itemArray.push(entryGroup.JournalCode);
					itemArray.push(entryGroup.ReferenceNo);
					itemArray.push(entry.AccountNumber);
					itemArray.push(entry.Description);
					itemArray.push(leftAmt);
					itemArray.push(rightAmt);
					entries.push(itemArray.join(','));
				});
			});
			var file = entries.join('\n');
			var blob = new Blob([file], { type: 'text/csv' });
			saveAs(blob, 'journal.csv');
		}

		function openReport(model, reportParams) {
			$scope.isReportFinished = false;
			model.message = BUSY_MESSAGE.GeneratingReport;
			$scope.loadingPromise = $scope.reportInterval = $interval(function () {
				if ($scope.isReportFinished) {
					$interval.cancel($scope.reportInterval);
					$scope.isReportFinished = false;
				}
			}, 1000);

			reportHelper.getReport($scope, '/api/fundreports/journalentryreport', reportParams, 'JournalEntryReport.pdf');
		}

		function sortby(model, propertyName) {
			model.filter.reverse = model.filter.propertyName === propertyName ? !model.filter.reverse : false;
			model.filter.propertyName = propertyName;
		}

		return angular.extend(model, {
			loadAccountStructures: _.partial(loadAccountStructures, model),
			loadFiscalYears: _.partial(loadFiscalYears, model),
			loadCurrentFY: _.partial(loadCurrentFY, model),
			loadUsesNcNewAcctStructure: _.partial(loadUsesNcNewAcctStructure, model),
			toggleThirteenthOption: _.partial(toggleThirteenthOption, model),
			getJournalEntries: _.partial(getJournalEntries, model),
			getSavedJournalEntries: _.partial(getSavedJournalEntries, model),
			getSavedJournalEntriesCount: _.partial(getSavedJournalEntriesCount, model),
			loadJournalCodes: _.partial(loadJournalCodes, model),
			setEntryAmounts: _.partial(setEntryAmounts, model),
			setEntryAmountsForVoid: _.partial(setEntryAmountsForVoid, model),
			getAmountForTransactionHistoryTable: _.partial(getAmountForTransactionHistoryTable, model),
			addJournalEntries: _.partial(addJournalEntries, model),
			voidJournalEntry: _.partial(voidJournalEntry, model),
			openListReport: _.partial(openListReport, model),
			exportJournalEntries: _.partial(exportJournalEntries, model),
			openReport: _.partial(openReport, model),
			sortby: _.partial(sortby, model),
		});
	}
}
